import { Spinner } from '@ds';

export const OnScreenLoader = () => (
  <div
    className="absolute top-0 left-0 w-full h-full z-999 flex items-center justify-center"
    style={{
      backgroundColor: 'rgba(51, 53, 63, 0.4)',
    }}
  >
    <div className="flex items-center justify-center p-2 rounded-md bg-white">
      <Spinner size="md" />
    </div>
  </div>
);
